import(/* webpackMode: "eager" */ "/src/src/app/[variants]/error.tsx");
